"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ParseClientAppConfigError = void 0;
exports.parseClientAppConfig = parseClientAppConfig;
var _error = require("@ori/error");
var _constants = require("./constants");
var _internals = require("./internals");
var ParseClientAppConfigError = exports.ParseClientAppConfigError = (0, _error.createCustomError)('ParseClientAppConfigError', {
    MISSING_PROPERTY: _constants.MISSING_PROPERTY
});
/**
 * Parses and validates a JSON string into an object typed by provided type as client application configuration.
 * JSON string can be obtained e.g. from HTML attribute `data-config` of the client application root element.
 * @param config A JSON string. Preferably valid. Invalid JSON string throws an error.
 * @param requiredProperties Properties required by the client application. Properties are validated if exist in client application configuration and have a valid value. Otherwise an error is thrown.
 * @returns Valid client application configuration.
 */ function parseClientAppConfig(config) {
    var requiredProperties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var parsedClientAppConfig = (0, _internals.safeParseJson)(config);
    requiredProperties.forEach(function(property) {
        if (!(0, _internals.isValidClientAppConfigProperty)(parsedClientAppConfig, String(property))) {
            throw new ParseClientAppConfigError('MISSING_PROPERTY', {
                messageParameters: [
                    String(property)
                ]
            });
        }
    });
    return parsedClientAppConfig;
} //# sourceMappingURL=parseClientAppConfig.js.map
